import './nbda-membership.modal.scss';

export default function NbdaMembershipModal($scope, $q, close) {
  'ngInject';

  $scope.modal = {
    membership: false
  };

  $scope.ok = (form) => {
    close($scope.modal)
  };

  $scope.close = () => {
    close();
  };

}